module.exports = __webpack_public_path__ + "img/designer-portfolio.7f4889d4.png";